import "core-js/modules/es.number.to-fixed.js";
import React from 'react';
import { Box, Typography, GRAY } from '@applyboard/ui-components';
export var Grade = function Grade(_ref) {
  var type = _ref.type,
    grade = _ref.grade,
    _ref$displayAsDecimal = _ref.displayAsDecimal,
    displayAsDecimal = _ref$displayAsDecimal === void 0 ? true : _ref$displayAsDecimal;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      color: GRAY[10]
    }
  }, type), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    style: {
      color: GRAY[5]
    }
  }, displayAsDecimal ? grade.toFixed(1) : grade));
};